// src/services/changePasswordService.jsx
import http from "./http";

// change admin password
export const changePassword = async (payload) => {
  // payload: { old_password, new_password, confirm_password }
  const res = await http.post("changeAdminPassword", payload);
  return res.data;
};
